import { LOCATION_CHANGE } from '../types';

const initialState = {
    routes: [],
    previous: '',
};

export default function historyReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case LOCATION_CHANGE:
            return {
                routes: [...state.routes, payload.location.pathname],
                previous: state.routes[state.routes.length - 1] || '',
            };
        default:
            return state;
    }
}
